import PropTypes from 'prop-types'
import { motion, AnimatePresence } from 'framer-motion'
import { NavLink } from 'react-router-dom'
import { sections, navConfig } from '../config/navigationConfig'
import { SocialLinks } from '../shared/SocialLinks'
import { ThemeToggle } from '../../ui/ThemeToggle'
import { useTheme } from '../../../contexts/ThemeContext'

export const MobileNav = ({ isMenuOpen, setIsMenuOpen }) => {
  const { isDark } = useTheme()

  return (
    <AnimatePresence>
      {isMenuOpen && (
        <motion.div
          {...navConfig.mobileMenuTransition}
          className={`
            md:hidden border-t
            ${isDark ? 'bg-neutral-950 border-neutral-800' : 'bg-white border-neutral-200'}
          `}
        >
          <div className="flex flex-col p-4 space-y-1">
            {Object.entries(sections).map(([key, { title, path }]) => (
              <NavLink
                key={key}
                to={path}
                onClick={() => setIsMenuOpen(false)}
                className={({ isActive }) => `
                  px-3 py-2.5 rounded-lg text-sm transition-colors
                  ${isActive 
                    ? isDark ? 'text-accent-400 bg-neutral-800' : 'text-accent-600 bg-neutral-100'
                    : isDark ? 'text-neutral-300 hover:bg-neutral-800' : 'text-neutral-700 hover:bg-neutral-100'
                  }
                `}
              >
                {title}
              </NavLink>
            ))}
          </div>
          <div className={`border-t px-4 py-3 flex items-center justify-between ${isDark ? 'border-neutral-800' : 'border-neutral-200'}`}>
            <span className={`text-xs ${isDark ? 'text-neutral-500' : 'text-neutral-400'}`}>Theme</span>
            <ThemeToggle />
          </div>
          <div className={`border-t px-4 py-3 ${isDark ? 'border-neutral-800' : 'border-neutral-200'}`}>
            <SocialLinks isMobile />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

MobileNav.propTypes = {
  isMenuOpen: PropTypes.bool.isRequired,
  setIsMenuOpen: PropTypes.func.isRequired
}